const ErrorCodes = {
  UnmountError: -200001,
  EndThreadError: -200002,
  ServiceResponseError: -400000,
  UnexpectedConditionError: -500000
};

export default ErrorCodes;



// WEBPACK FOOTER //
// ./src/error/error-codes/index.js